import * as React from 'react';

import {
  UseViewSwitcherOptions,
  UseViewSwitcherReturn,
  ViewSwitcherToggleProps,
  ViewType,
} from './types';
import { ViewSwitcherToggle } from './view-switcher-toggle';

const STORAGE_KEY_DEFAULT = 'view-switcher-preference';

export const useViewSwitcher = (
  options: UseViewSwitcherOptions = {}
): UseViewSwitcherReturn => {
  const {
    defaultView = 'table',
    persistView = false,
    storageKey = STORAGE_KEY_DEFAULT,
  } = options;

  // Get initial view from localStorage if persistence is enabled
  const getInitialView = (): ViewType => {
    if (persistView && typeof window !== 'undefined') {
      const stored = localStorage.getItem(storageKey);
      if (stored === 'card' || stored === 'table') {
        return stored;
      }
    }
    return defaultView;
  };

  const [view, setViewState] = React.useState<ViewType>(getInitialView);

  const setView = React.useCallback(
    (newView: ViewType) => {
      setViewState(newView);
      if (persistView && typeof window !== 'undefined') {
        localStorage.setItem(storageKey, newView);
      }
    },
    [persistView, storageKey]
  );

  const ViewToggle: React.FC<
    Omit<ViewSwitcherToggleProps, 'value' | 'onChange'>
  > = React.useMemo(() => {
    const Component: React.FC<
      Omit<ViewSwitcherToggleProps, 'value' | 'onChange'>
    > = (props) => {
      return React.createElement(ViewSwitcherToggle, {
        value: view,
        onChange: setView,
        ...props,
      });
    };
    return Component;
  }, [view, setView]);

  return {
    view,
    setView,
    ViewToggle,
  };
};
